import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const BNZ_BANK_WIDE_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_BANK_WIDE_ENABLED');

export const BNZ_STAR_ICON_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_STAR_ICON_ENABLED');

export const BNZ_DEPRECATE_FLYBUYS_SCHEME_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_DEPRECATE_FLYBUYS_SCHEME_ENABLED');

export const BNZ_CASHBACK_DESCRIPTOR_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_CASHBACK_DESCRIPTOR_ENABLED');

export const BNZ_USER_HAS_ENROLLMENTS: InjectionToken<Observable<boolean>> =
  new InjectionToken<Observable<boolean>>('BNZ_USER_HAS_ENROLLMENTS');

export const BNZ_POINTS_ACTIVITY_ENHANCE_UNLEASH_KEY =
  'bnz_points_activity_enhance';
export const BNZ_POINTS_ACTIVITY_ENHANCE_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_POINTS_ACTIVITY_ENHANCE_ENABLED');

export const BNZ_DISPLAY_POINTS_EXPIRY_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_DISPLAY_POINTS_EXPIRY_ENABLED');

export const BNZ_AUTO_REDEMPTION_UPDATE_UNLEASH_KEY =
  'bnz_auto_redemption_update';

export const BNZ_AUTO_REDEMPTION_UPDATE_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_AUTO_REDEMPTION_UPDATE_ENABLED');

export const BNZ_HOMEPAGE_BANNER_IMAGE_UNLEASH_KEY =
  'bnz_homepage_banner_image';
export const BNZ_HOMEPAGE_BANNER_IMAGE_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_HOMEPAGE_BANNER_IMAGE_ENABLED');

export const BNZ_OFFERS_BANNER_IMAGE_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_OFFERS_BANNER_IMAGE_ENABLED');

export const BNZ_TC_BANNER_IMAGE_UNLEASH_KEY = 'bnz_tc_banner_image';
export const BNZ_RC_BANNER_IMAGE_UNLEASH_KEY = 'bnz_rc_banner_image';
export const BNZ_GC_BANNER_IMAGE_UNLEASH_KEY = 'bnz_gc_banner_image';

export const BNZ_BANKWIDE_CAROUSEL_UPDATE_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_BANKWIDE_CAROUSEL_UPDATE_ENABLED');

export const BNZ_BANKWIDE_UPDATES_UNLEASH_KEY = 'bnz_bankwide_updates';
export const BNZ_BANKWIDE_UPDATES_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_BANKWIDE_UPDATES_UNLEASH_ENABLED');

export const BNZ_BANKWIDE_LOGIN_COPY_UPDATE: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_BANKWIDE_LOGIN_COPY_UPDATE');

export const BNZ_VOX_UNLEASH_KEY = 'use_vox_frontend';
export const BNZ_VOX_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('BNZ_VOX_ENABLED');
